const rule = {
    username: [{
        required: true,
        pattern : "^[\u4e00-\u9fa5][\u4e00-\u9fa5]+[0-9]*$",
        message: '请填写正确的姓名',
        trigger: 'blur'
    }],
    tkphone:[{
        required: true,
        pattern : "^(0|86|17951)?1[3456789][0-9]{9}$",
        message: '请填写正确的手机号',
        trigger: 'blur'
    }],
    company_group_id: [{
        required: true,
        type: 'string',
        message: '请选择部门',
        trigger: 'change'
    }],
};

export default rule;


// WEBPACK FOOTER //
// ./src/validateRule/company/addMember.js